import h from "./design-system.es58.js";
import y from "./design-system.es95.js";
import { resolveComponent as f, openBlock as a, createBlock as m, resolveDynamicComponent as v, normalizeClass as p, withCtx as B, createCommentVNode as r, createTextVNode as u, createElementBlock as g, renderSlot as d, createVNode as b } from "vue";
/* empty css                    */
import _ from "./design-system.es128.js";
const x = {
  name: "DsButton",
  components: {
    Icon: h,
    Spinner: y
  },
  props: {
    /**
     * Name of the element type to render the Button as.  Defaults to a button element, but can be used to render an anchor for links that look like buttons.
     */
    as: {
      type: String,
      default: "button"
    },
    /**
     * The type attribute used by the rendered button, i.e. button, submit, reset.  Defaults to button.  This will not be used if the `as` prop is overriden.
     */
    type: String,
    /**
     * The button variant.  This will be used to determine the styling of the button.  Defaults to 'filled'.
     */
    variant: {
      type: String,
      default: "filled",
      validator: (t) => ["filled", "outline", "text", "custom"].includes(t)
    },
    /**
     * Styles as a gray variant of the text/filled button.
     */
    gray: Boolean,
    /**
     * Styles as a destructive variant.
     */
    destructive: Boolean,
    /**
     * Styles as a dense variant.
     */
    dense: Boolean,
    /**
     * Fill available horizontal space.
     */
    fill: Boolean,
    /**
     * Renders as a loading indicator instead of text.
     */
    loading: Boolean,
    /**
     * Disables the button.
     */
    disabled: Boolean,
    /**
     * Name of the icon to render in the leading slot.
     */
    leadingIcon: String,
    /**
     * Name of the icon to render in the trailing slot.
     */
    trailingIcon: String
  },
  computed: {
    classes() {
      const {
        variant: t,
        destructive: e,
        dense: n,
        fill: c,
        gray: l,
        loading: i,
        hasLeading: s,
        hasTrailing: o
      } = this;
      return {
        "ds-button--filled": t === "filled" && !l && !e,
        "ds-button--filled-gray": t === "filled" && l,
        "ds-button--filled-destructive": t === "filled" && e,
        "ds-button--outline": t === "outline" && !e,
        "ds-button--outline-destructive": t === "outline" && e,
        "ds-button--text": t === "text" && !l && !e,
        "ds-button--text-gray": t === "text" && l,
        "ds-button--text-destructive": t === "text" && e,
        "ds-button--dense": n,
        "ds-button--fill": c,
        "ds-button--with-leading": s,
        "ds-button--with-trailing": o,
        // legacy classes kept for selector backwards compatibility
        "text-button": t === "text",
        outline: t === "outline",
        negative: e,
        gray: l,
        dense: n,
        "with-leading": s,
        "with-trailing": o,
        loading: i
      };
    },
    buttonType() {
      return this.as !== "button" ? null : this.type === void 0 ? "button" : this.type || null;
    },
    hasLeading() {
      return this.$slots.leading || this.leadingIcon;
    },
    hasTrailing() {
      return this.$slots.trailing || this.trailingIcon;
    }
  }
}, I = {
  key: 1,
  class: "leading"
}, S = { key: 2 }, k = {
  key: 4,
  class: "trailing"
};
function T(t, e, n, c, l, i) {
  const s = f("Spinner"), o = f("Icon");
  return a(), m(v(n.as), {
    type: i.buttonType,
    class: p(["button ds-button", i.classes]),
    disabled: n.disabled || n.loading ? !0 : void 0
  }, {
    default: B(() => [
      n.loading ? (a(), m(s, {
        key: 0,
        class: "button-loading-spinner"
      })) : r("", !0),
      e[0] || (e[0] = u()),
      i.hasLeading ? (a(), g("div", I, [
        d(t.$slots, "leading", {}, () => [
          b(o, { name: n.leadingIcon }, null, 8, ["name"])
        ], !0)
      ])) : r("", !0),
      e[1] || (e[1] = u()),
      i.hasLeading || i.hasTrailing || n.loading ? (a(), g("div", S, [
        d(t.$slots, "default", {}, void 0, !0)
      ])) : d(t.$slots, "default", { key: 3 }, void 0, !0),
      e[2] || (e[2] = u()),
      i.hasTrailing ? (a(), g("div", k, [
        d(t.$slots, "trailing", {}, () => [
          b(o, { name: n.trailingIcon }, null, 8, ["name"])
        ], !0)
      ])) : r("", !0)
    ]),
    _: 3
  }, 8, ["type", "class", "disabled"]);
}
const V = /* @__PURE__ */ _(x, [["render", T], ["__scopeId", "data-v-32894717"]]);
export {
  V as default
};
//# sourceMappingURL=design-system.es38.js.map
